// extracted by mini-css-extract-plugin
export default {"tumbleweed":"#dab177","ability":"Bp","content":"Bq","content-left":"Br","contentLeft":"Br","content-right":"Bs","contentRight":"Bs","header":"Bt","padded":"Bu","wrapper":"Bv"};